export default __webpack_public_path__ + "static/media/FatigueImg.a1e243d7.jpg";